import {withTheme} from '@rn-vui/themed';

import DateOfBirthInput from '../ui-controls/DateOfBirthInput';

type Props = React.ComponentProps<typeof DateOfBirthInput>;

export default withTheme<Props>(DateOfBirthInput, 'DateOfBirthInput');

declare module '@rn-vui/themed' {
  export interface ComponentTheme {
    DateOfBirthInput: Partial<Props>;
  }
}
